import { Location, DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalizeParser, LocalizeRouterModule, LocalizeRouterSettings } from 'localize-router';
import { LocalizeRouterHttpLoader } from 'localize-router-http-loader';
import { CanActivateAuthGuard } from './core/can-activate-auth.guard';
import { LoginAuthGuard } from './core/login-auth.guard';
import { environment as env} from 'src/environments/environment';
import { I18n, CustomDatepickerI18n } from './config/custom-date-picker-i18n';
import { NgbDatepickerI18n, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateISOParserFormatter } from './config/custom-date-iso-parser-formatter';

export function HttpLoaderFactory(translate: TranslateService, location: Location, settings: LocalizeRouterSettings, http: HttpClient) {
  // Read ==> https://github.com/Greentube/localize-router#localizerouterconfig
  // translate.onLangChange.subscribe((event: LangChangeEvent) => { Log.debug(event); });
  return new LocalizeRouterHttpLoader(translate, location, settings, http, env.localeUrl);
}

/**
 * data: {skipRouteLocalization: true} this route will not be localized
 */
const routes: Routes = [
  {
    path: 'login',
    loadChildren: './page/login/login.module#LoginModule',
    canActivate: [LoginAuthGuard] // todo open comment
  },
  {
    path: 'home',
    loadChildren: './page/home/home.module#HomeModule',
    canActivate: [CanActivateAuthGuard] // todo open comment
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  // otherwise redirect to home
  { path: '**', redirectTo: '/login' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    LocalizeRouterModule.forRoot(routes, {
      parser: {
        provide: LocalizeParser,
        useFactory: (HttpLoaderFactory),
        deps: [TranslateService, Location, LocalizeRouterSettings, HttpClient]
      }
    })
  ],
  exports: [RouterModule, LocalizeRouterModule],
  providers: [
    I18n,  DatePipe,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
    { provide: NgbDateParserFormatter, useClass: CustomDateISOParserFormatter },
  ],
})
export class AppRoutingModule {
}
